import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';

import { Select, DateRangePicker } from 'ui/components';
import { formatDate } from 'utilities/common';

const statusOptions = [
  { value: 'fulfilled', label: 'Baru' },
  { value: 'checked', label: 'Sudah Dicek' },
  { value: 'completed', label: 'Selesai' },
];

const initialState = {
  document_status: null,
  shipping_date: null,
};

const Filter = ({ show, onClose, table, setCount }) => {
  const [{ status, shipping_date }, setState] = React.useState(initialState);

  const $onLoad = async () => {
    let date = [];

    if (
      table.State?.filter?.start_at &&
      table.State?.filter?.end_at
    ) {
      const x = table.State?.filter?.start_at;

      date.push(new Date(x));

      const y = table.State?.filter?.end_at;
      date.push(new Date(y));
      setState((prevState) => ({
        ...prevState,
        shipping_date: date,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        shipping_date: null,
      }));
    }

    setState((prevState) => ({
      ...prevState,
      status:
        table?.State?.filter?.document_status === 'fulfilled'
          ? statusOptions[0]
          : table?.State?.filter?.document_status === 'checked'
          ? statusOptions[1]
          : table?.State?.filter?.document_status === 'completed'
          ? statusOptions[2]
          : null,
    }));
  };

  const handleFilter = async (e) => {
    if (table?.State?.filter) {
      let x = [];
      Object.keys(table?.State?.filter).forEach((k) => {
        if (table?.State?.filter[k] && k !== 'start_at' && k !== 'warehouse_id') {
          x.push(k);
        }
      });

      setCount(x);
    }
  };

  const handleStatus = (e) => {
    setState((prevState) => ({
      ...prevState,
      status: e,
    }));
    table.filter('document_status', e?.value);
    handleFilter();
  };

  React.useEffect(() => {
    $onLoad();
  }, []);

  React.useEffect(() => {
    handleFilter();
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Status</div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            options={statusOptions}
            value={status}
            onChange={handleStatus}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Jadwal Fulfillment
          </div>
          <DateRangePicker
            value={shipping_date}
            placeholder=""
            onChange={(date) => {
              setState((prevState) => ({
                ...prevState,
                shipping_date: date,
              }));
              let fm = [];
              date?.forEach((data) => fm?.push(formatDate(data, 'YYYY-MM-DD')));
              if (fm?.length > 0) {
                table.filter('start_at', fm[0]);
                table.filter('end_at', fm[1]);
                handleFilter();
              } else {
                table.filter('start_at', null);
                table.filter('end_at', null);
                handleFilter();
              }
            }}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Status</div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              options={statusOptions}
              value={status}
              onChange={handleStatus}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Jadwal Fulfillment
            </div>
            <DateRangePicker
              value={shipping_date}
              placeholder=""
              onChange={(date) => {
                setState((prevState) => ({
                  ...prevState,
                  shipping_date: date,
                }));
                let fm = [];
                date?.forEach((data) =>
                  fm?.push(formatDate(data, 'YYYY-MM-DD'))
                );
                if (fm?.length > 0) {
                  table.filter('start_at', fm[0]);
                  table.filter('end_at', fm[1]);
                  handleFilter();
                } else {
                  table.filter('start_at', null);
                  table.filter('end_at', null);
                  handleFilter();
                }
              }}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
